import { createGlobalStyle } from "styled-components";
import "./fonts/font.scss";

export default createGlobalStyle`
    input:focus,
    select:focus,
    textarea:focus,
    button:focus {
        outline: none;
    }

    body{
        /* font-family:'roboto-light'; */
    }

    .modal-open{
        overflow: hidden !important;
    }
`;
